function canTrack() {
  return import.meta.env.PROD && !import.meta.env.SSR && typeof window !== 'undefined'
}

export function trackEvent(name, params = {}) {
  if (!canTrack()) return
  import('vue-gtag').then(({ event }) => {
    event(name, params)
  })
}

export function setAnalyticsUser(user) {
  if (!canTrack()) return
  if (user?.id) {
    import('vue-gtag').then(({ config }) => {
      config({ user_id: String(user.id) })
    })
  }
}
